import React from "react";
import { AppBar, UserMenu, MenuItemLink, translate } from "react-admin";
import Flag from "@material-ui/icons/Flag";
import SpeakerNotes from "@material-ui/icons/SpeakerNotes";
import PersonPin from "@material-ui/icons/PersonPin";
import MotorCycle from "@material-ui/icons/Motorcycle";
import DeviceHub from "@material-ui/icons/DeviceHub";
import AddLocation from "@material-ui/icons/AddLocation";
import Games from "@material-ui/icons/Games";
import { canAccess } from "./rbac";
import DocumentationReminderBell from "./components/DocumentationReminderBell";

const CONFIG_MENU_ITEMS = [
  { to: "/users", text: "Users", icon: <PersonPin />, permission: "users" },
  { to: "/guides", text: "Guides", icon: <PersonPin />, permission: "guides" },
  { to: "/countries", text: "Countries", icon: <Flag />, permission: "countries" },
  { to: "/locations", text: "Locations", icon: <AddLocation />, permission: "locations" },
  { to: "/holidays", text: "Holidays", icon: <Flag />, permission: "holidays" },
  { to: "/tour_names", text: "Tour Names", icon: <SpeakerNotes />, permission: "tour_names" },
  { to: "/vehicle_models", text: "Vehicle Models", icon: <MotorCycle />, permission: "vehicle_models" },
  { to: "/maintenance_item_types", text: "Maintenance Item Types", icon: <DeviceHub />, permission: "maintenance_item_types" },
  { to: "/maintenance_items", text: "Maintenance Items", icon: <Games />, permission: "maintenance_items" },
];

const CustomUserMenu = translate(({ onMenuClick, ...props }) => (
  <UserMenu {...props}>
    {CONFIG_MENU_ITEMS.map(({ to, text, icon, permission }) =>
      canAccess(permission) ? (
        <MenuItemLink
          key={to}
          to={to}
          primaryText={text}
          onClick={onMenuClick}
          leftIcon={icon}
        />
      ) : null
    )}
  </UserMenu>
));

const UserMenuWithNotifications = props => (
  <div style={{ display: "flex", alignItems: "center" }}>
    <DocumentationReminderBell />
    <CustomUserMenu {...props} />
  </div>
);

const CustomAppBar = props => (
  <AppBar {...props} userMenu={<UserMenuWithNotifications {...props} />} />
);

export default CustomAppBar;



// WEBPACK FOOTER //
// ./src/AppBar.js